
  <div class="flex-grow-1 d-flex">
    <ds-icon
      [name]="iconPrefix + '-icon-checkmark-outlined'"
      class="mr-8"
      [color]="'success'">
    </ds-icon>
    <div>
        <p class="text-body">
      <span>
        <div>
          <b>{{ 'passkey.profile.removedPasskey' | translate }}</b>
        </div>
      </span>
      </p>
    </div>
  </div>

   <div class="text-body-lg mb-10 mt-10">
     <p>{{ 'passkey.profile.email' | translate }}</p> <b>{{userEmail}}</b>
   </div>
   <div class="text-body-lg mb-10 mt-10">
    <p>{{ 'passkey.profile.instructions' | translate }}</p> 
   </div>

    <div class="mb-8 ds-body-r mb-0" style="cursor: pointer;">
      <div>
        <a ds-link variant="cta" class="mt-4 ds-color-link"
         target="_blank" href="{{iosLink}}">{{ 'passkey.profile.ios' | translate }}
        <ds-icon class="ml-2 size-24" name="open-new"caption="iOS support"></ds-icon>  
       </a>
      </div>
      <div>
        <a ds-link variant="cta" class="mt-4 ds-color-link"
         target="_blank" href="{{andriodLink}}">{{ 'passkey.profile.android' | translate }}
        <ds-icon class="ml-2 size-24" name="open-new"caption="Android support"></ds-icon>   
        </a>
      </div>
      <div>
        <a ds-link variant="cta" class="mt-4 ds-color-link"
         target="_blank" href="{{chromeLink}}">{{ 'passkey.profile.chrome' | translate }}
        <ds-icon class="ml-2 size-24" name="open-new"caption="Google Chrome support"></ds-icon>   
        </a>
      </div>
      <div>
        <a ds-link variant="cta" class="mt-4 ds-color-link"
         target="_blank" href="{{edgeLink}}">{{ 'passkey.profile.edge' | translate }}
        <ds-icon class="ml-2 size-24" name="open-new"caption="Microsoft Edge support"></ds-icon>   
        </a>
      </div>
      <div>
        <a ds-link variant="cta" class="mt-4 ds-color-link"
         target="_blank" href="{{safariLink}}">{{ 'passkey.profile.safari' | translate }}
        <ds-icon class="ml-2 size-24" name="open-new"caption="Safari support"></ds-icon>   
        </a>
      </div>

    </div>

   <button
    type="submit"
    ds-button
    class="w-100 mt-12"
    (click)="onCloseClick()"
    title="{{ 'passkey.profile.close' | translate }}"
    >
    <span>{{ 'passkey.profile.close' | translate }}</span>
    </button>